import React from "react";
import { useChannelIOApi } from "react-channel-plugin";
import { Button } from "../../Components/StyledComponents";
import "./ReqTabletOrder.scss";

const ReqTabletOrder = () => {
  const { showMessenger } = useChannelIOApi();

  return (
    <div className="req-order">
      <p className="text">인건비 부담, 한 방에 해결</p>
      <p className="title">시럽프렌즈 태블릿 오더</p>
      <div className="order-desc">
        <div className="row">
            <p className="desc-text">간편한 홀 관리의 시작,</p>
            <p className="title-text">&nbsp;태블릿 오더</p>
        </div>
        <Button
            variant="outline"
            fontSize={14}
            style={{ width: 150, height: 40, padding: 0 }}
            onClick={() =>
            (window.location.href = "https://home.syrupfriends.com/tableorder")
            }
        >
            태블릿 오더 구경하기
        </Button>
      </div>
      {/* <div className="order-desc">
        <div className="row">
            <p className="desc-text">기능은 그대로! 비용 부담은 DOWN!</p>
            <p className="title-text">&nbsp;메뉴판형 태블릿 오더</p>
        </div>
        <Button
            variant="outline"
            fontSize={14}
            style={{ width: 200, height: 40, padding: 0 }}
            onClick={() =>
            (window.location.href = "https://home.syrupfriends.com/tableorder")
            }
        >
            메뉴판형 태블릿 오더 구경하기
        </Button>
      </div>
      <div className="order-desc">
        <div className="row">
        <p className="desc-text">기기 비용 NO! 태그 한 번이면 OK!</p>
        <p className="title-text">&nbsp;QR/NFC오더</p>
        </div>
        <Button
            variant="outline"
            fontSize={14}
            style={{ width: 163, height: 40, padding: 0 }}
            onClick={() =>
            (window.location.href = "https://home.syrupfriends.com/tableorder")
            }
        >
            OR/NFC 오더 구경하기
        </Button>
      </div> */}
      <Button
        variant="sub"
        style={{ width: 114, marginTop: 64 }}
        onClick={showMessenger}
      >
        상담 문의하기
      </Button>
    </div>
  );
};

export default ReqTabletOrder;
